export const modifyCommissionRate = (slabData, flatData, type) => {
    // console.log(type, "TYPE-------------------");
    // console.log(flatData, slabData, "<modifyCommissionRate>");
    // console.log(type, flatData, slabData, "<modifyCommissionRate>");
    if (type === "flat") {
        return {
            type: type,
            commissionType: type,
            minAmount: 0,
            maxAmount: 0,
            percentage: flatData.type === "PERCENTAGE" ? flatData.value : 0,
            flatAmount: flatData.type === "RUPEES" ? flatData.value : 0
        };
    }

    if (type === "slab") {
        const arr = [];

        slabData?.forEach((val) => {
            // console.log(val, "val----12345");
            arr.push({
                type: type,
                commissionType: type,
                minAmount: val.from,
                maxAmount: val.to,
                percentage: val.type === "PERCENTAGE" ? val.value : 0,
                flatAmount: val.type === "RUPEES" ? val.value : 0
            });
        });

        return arr;
    }

    return null;
};

export const modifyCommissionSlabRate = (data, type) => {

    // console.log(data, "ddddd")

    // console.log(data, "<slab----data>");
    const arr = [];

    data?.forEach((val) => {
        arr.push({
            minAmount: val.from,
            maxAmount: val.to,
            percentage: val.currency === "PERCENTAGE" ? val.amount : 0,
            flatAmount: val.currency === "RUPEES" ? val.amount : 0,
            commissionType: "slab"
        });
    });

    return arr;

};

